/**************************************************
 * original
 **************************************************/
const workhouse = {
  common: {},
  top: {},
  itemList: {},
  itemDetail: {},
  cart: {},
  brandlist: {},
  faq: {},
  inquiry: {},
  coordinate: {},
  shop: {},
  about: {}
};

/**
 * PCヘッダーのカテゴリメニューのスライダー
 */
workhouse.common.categoryMenuSlider = function() {
  //対象のスライド
  const slideTarget = document.querySelector('.js-category-menu-slider');
  // Swiper初期化
  new Swiper(slideTarget, {
    slidesPerView: 'auto',
    spaceBetween: 8,
    // freeModeの設定をオブジェクト形式で詳細に指定
    freeMode: {
      enabled: true,      // 自由移動を有効化
      sticky: false,     // 停止時にスライドの位置にスナップするのを防ぐ（重要！）
      momentum: true,    // 慣性スクロールを有効にして「スクロール感」を出す
      momentumRatio: 1,  // 慣性の強さ（1が標準）
    },
    grabCursor: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
};

/**
 * 商品リストのスライダー（NEW ARRIVAL / 関連商品）
 */
workhouse.common.itemlist = function() {
  //対象のスライド
  const slideTargets = document.querySelectorAll('.js-itemlist-swiper');

  // 要素がなければ処理終了
  if (!slideTargets.length) {
    return;
  }

  // swiper初期化
  slideTargets.forEach(function (slideTarget) {
    // すでに初期化済みなら何もしない
    if (slideTarget.swiper) {
      return;
    }

    // トップページのNEW ARRIVALの設定（デフォルト値）
    let pcPerView = 4;// PCの商品の表示枚数
    let pcSpaceBetween = 17;// PCの商品間の余白

    // ニュース内の関連商品の場合は、再宣言
    if (slideTarget.classList.contains('js-news-related-swiper')){
      pcPerView = 5;
      pcSpaceBetween = 26;
    }

    // swiper初期化
    new Swiper(slideTarget, {
      slidesPerView: 'auto',
      freeMode: {
        enabled: true,
        sticky: true, // スナップ
      },
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // 
      observer: true,
      observeParents: true,
      breakpoints: {
        [illm.common.breakpoint.minPc]: {
          slidesPerView: pcPerView,
          spaceBetween: pcSpaceBetween,
        }
      }
    });
  });
};

/**
 * メインビジュアルのスライダー
 */
workhouse.top.mainvisual = function() {
  const slideAutoplay = Boolean($('#illm-slide_autoplay').attr('date-info'));//自動再生: true
  const slideAutoplaySpeed = parseInt($('#illm-slide_autoplay_speed').attr('date-info'));//自動再生時の静止時間: 4000ms
  const slideSpeed = parseInt($('#illm-slide_speed').attr('date-info'));//スライドアニメーションの速度: 600ms
  // const slideArrow = Boolean($('#illm-slide_arrow').attr('date-info'));//左右矢印の表示: true
  // const slideDot = Boolean($('#illm-slide_dot').attr('date-info'));//ドットの表示: true
  const slideTarget = document.querySelector('.js-home-visual-swiper');//対象のスライド

  // スライドが1枚なら Swiper 自体不要
  const slideCount = slideTarget.querySelectorAll('.swiper-slide').length;
  if (slideCount <= 1) {
    return;
  }

  // Swiper初期化
  const homeVisualSwiper = new Swiper(slideTarget, {
    slidesPerView: 1,
    speed: slideSpeed,
    // 自動再生
    autoplay: slideAutoplay ? {
      delay: slideAutoplaySpeed,
    } : false,
    allowTouchMove: true,
    loop: slideCount > 1,
    // ナビゲーション（矢印）
    /*navigation: slideArrow ? {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    } : false,
    // ページネーション（ドット）
    pagination: slideDot ? {
      el: ".swiper-pagination",
      clickable: true,
    } : false, */
  });
};

/**
 * メインビジュアル下部のバナーのスライダー
 */
workhouse.top.mainbanner = function() {
  //対象のスライド
  const slideTarget = document.querySelector('.js-home-banner-swiper');
  // Swiper初期化
  const homeBannerSwiper = new Swiper(slideTarget, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    freeMode: true,          // カチッと止まらない
    momentum: false,          // 慣性スクロール
    grabCursor: true,
    breakpoints: {
      [illm.common.breakpoint.minPc]: {
        loop: true,
        spaceBetween: 15,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      }
    }
  });
};

/**
 * COORDINATEのスライダー（トップページ）
 */
workhouse.top.coordinateSlider = function() {
  //対象のスライド
  const slideTarget = document.querySelector('.js-coordinate-swiper');
  // swiper初期化
  const coordinateSwiper = new Swiper(slideTarget, {
    slidesPerView: 1.2,
    centeredSlides: true,
    loop: true,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      [illm.common.breakpoint.minPc]: {
        slidesPerView: 3.2,
      }
    }
  });
};


// 商品画像のサムネイルのスライダー
workhouse.itemDetail.thumbnailSlider = function() {
  //対象のスライド
  const slideTarget = document.querySelector('.js-thumbnail-list');

  // swiper初期化
  const thumbnailSwiper = new Swiper(slideTarget, {
    slidesPerView: 6,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    freeMode: {
      enabled: true,
      momentum: true,
    },
    breakpoints: {
      [illm.common.breakpoint.minPc]: {
        slidesPerView: 'auto',
      }
    }
  });

  // スウォッチを切り替えると、1枚目の写真が切り替わるので、スライダーの位置も最初に戻す
  document.addEventListener('change', (event) => {
    if (event.target.matches('.swatch-input__input')) {
      // スウォッチが切り替わるのに若干タイムラグがあるので、こっちも遅らせる
      setTimeout(() => {
        // Swiperを先頭位置（translateX = 0）に強制的に戻す
        thumbnailSwiper.setTranslate(0);
        // 現在のスクロール位置をもとに progress（0〜1）を再計算
        thumbnailSwiper.updateProgress();
        // activeIndex（現在アクティブなスライド）を再計算
        thumbnailSwiper.updateActiveIndex();
        // active / next / prev などのクラスを更新
        thumbnailSwiper.updateSlidesClasses();
      }, 500);
    }
  });

};

// JANコード取得
workhouse.itemDetail.getJancode = function() {
  // JANコード表示エリア
  const janEl = document.getElementById('jan-code');

  // 全バリエーション（LiquidでJSON化）
  const variants = window.productVariants;

  if (!janEl || !variants) return;

  /**
   * 現在チェックされている radio から
   * option値（カラー / サイズ）を取得
   * ※ Rise は DOM を差し替えるため、
   * 毎回 querySelector するのが重要
   */
  function getSelectedOptions() {
    return Array.from(
      document.querySelectorAll('input[type="radio"]:checked')
    ).map(radio => radio.dataset.option || radio.value);
  }

  /**
   * 選択中オプションに一致する variant を探し
   * JANコードを表示する
   */
  function updateJan() {
    const selectedOptions = getSelectedOptions();

    // デバッグ用
    console.log('selected options:', selectedOptions);

    // 全オプションが揃っていない場合は非表示
    if (selectedOptions.length !== variants[0].options.length) {
      janEl.textContent = '';
      return;
    }

    // variant.options と完全一致するものを探す
    const variant = variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    janEl.textContent = variant?.barcode
      ? `JANコード：${variant.barcode}`
      : '';
  }

  /**
   * ★ ここが重要 ★
   * document に change イベントを委譲する
   * → DOM が作り直されても必ず拾える
   */
  document.addEventListener('change', event => {
    const target = event.target;

    // radio 以外は無視
    if (
      target.matches('input[type="radio"]')
    ) {
      updateJan();
    }
  });

  // 初期表示
  updateJan();
};


/**
 * COORDINATEのスライダー（商品ページ）
 */
workhouse.itemDetail.coordinateSlider = function() {
  //対象のスライド
  const slideTarget = document.querySelector('.js-product-coordinate-swiper');
  // swiper初期化
  const coordinateSwiper = new Swiper(slideTarget, {
    slidesPerView: 2.1,
    centeredSlides: true,
    loop: true,
    spaceBetween: 15,
    breakpoints: {
      [illm.common.breakpoint.minPc]: {
        slidesPerView: 5,
        spaceBetween: 17,
      }
    }
  });
};

/**
 * 購入制御のため、数量変更・削除したらリロード
 */
workhouse.cart.refreshCartOnUpdate = function() {
  // 合計金額を監視対象
  const observerTarget = document.querySelector('.cart__blocks .js-contents');
  // 更新を検知する要素がなければ処理終了
  if (!observerTarget){
    return;
  }

  // 合計金額が変更されたら、リロード
  const observer = new MutationObserver(function (mutationsList, observer) {
    location.reload();
  });

  // 監視を開始
  observer.observe(observerTarget, {
    childList: true, // 直接の子要素の追加・削除を監視
    subtree: true // 子孫要素の変更も含めて監視
  });
};


/**
 * ブランドリストの絞り込み
 */
workhouse.brandlist.filter = function() {
  //キーワード検索の要素
  const allBrandSearchInputs = '#brandSearchInput';
  
  // A~Zにクリックイベントを設定
  $('.js-alphabet-nav button').click(function(event) {
    // 現在選択されているボタンのクラスを解除し、クリックされたボタンにクラスを追加
    $('.js-alphabet-nav button').removeClass('is-current');
    $(this).addClass('is-current');
    // デフォルトのリンク動作を防ぐ
    event.preventDefault();

    let searchFormInputVal;

    // 検索フォームの値を取得
    searchFormInputVal = $(allBrandSearchInputs).val();

    // 検索フォームに値が入ってたら、クリアして全ブランドを表示
    if(searchFormInputVal !== ""){
      $(allBrandSearchInputs).val(''); // 入力値を空にする
      $('.js-brand-list li').show(); // ブランド全表示
      $('.brand-list__content').show().removeClass('hidden');// 絞り込み表示を解除
    }
    
    // クリックしたボタンのdata-letter属性からターゲットのIDを取得
    const targetID = $(this).data('letter');
    if(targetID === 'all'){
      //ALLクリックしたら、すべて表示
      $('.brand-list__content').show().removeClass('hidden'); //絞り込み表示解除      
    }else{      
      // ターゲットのセクションを選択し、兄弟要素を非表示に
      $(`.initial-${targetID}`).show().siblings('.brand-list__content').hide();
    }
  });

  // ブランド検索フォームにフォーカスしたときの処理
  $(allBrandSearchInputs).focus(function() {
    // 'A~Z'ボタンの選択状態をリセット
    $('.js-alphabet-nav button').removeClass('is-current');
    if ($(this).val() === "") {
        // 入力値が空の場合、非表示になっている全てのブランドリストセクションを表示
        $('.brand-list__content').show();
    }
  });

  
  let debounceTimer;// デバウンス用のタイマーを格納する変数

  // 検索機能の処理
  $(allBrandSearchInputs).on('input', function() {
    const searchInput = $(this);

    // 以前のタイマーをクリア（リセット）
    clearTimeout(debounceTimer);

    /*
    * デバウンス処理: ユーザーの入力が止まってから検索を実行することで、
    * パフォーマンスを最適化し、不必要な処理を削減する。
    * 300msという遅延は、一般的なタイピング速度を考慮した妥当な時間。
    */
    debounceTimer = setTimeout(function() {
      const searchText = searchInput.val().toLowerCase(); // 入力された文字を取得して小文字に変換
      
      // 入力欄が空の場合は全てのリスト項目を表示
      if (searchText === "") {
        $('.js-brand-list li').show();
        $('.brand-list__content').show().removeClass('hidden');
      } else {
        // 入力値がある場合、全てのセクションを一時的に非表示にする
        $('.brand-list__content').addClass('hidden');

        // 各ブランドリスト項目を処理
        $('.js-brand-list li').each(function() {
          const listItemText = $(this).text().toLowerCase(); // 各リスト項目のテキストを小文字に変換
          
          // 入力された文字がリスト項目のテキストに部分一致するかチェック
          if (listItemText.indexOf(searchText) !== -1) {
            $(this).show(); // 一致する場合は表示
            // 一致した項目の親セクションを表示状態に戻す
            $(this).parents('.brand-list__content').removeClass('hidden');
          } else {
            $(this).hide(); // 一致しない場合は非表示
          }
        });
      }
    }, 300);
  });
  
};

/**
 * ブランドリストの絞り込み
 */
workhouse.faq.setupLayout = function() {
  // 各要素を取得
  const sidebar = document.querySelector('.faq-sidebar-section');// サイドナビ
  const faqSections = document.querySelectorAll('.faq__section');// 各FAQセクション

  // 要素が存在しない場合は処理を中断
  if (!sidebar || faqSections.length === 0) {
    return;
  }

  // ラッパーとなる要素を作成
  const wrapper = document.createElement('div');
  wrapper.className = 'page-width side-nav__wrapper';

  const pagesMain = document.createElement('div');
  pagesMain.className = 'pages-main';

  // 構造を組み立てる
  // sidebarの直前にラッパーを挿入し、その中にsidebarを移動
  sidebar.parentNode.insertBefore(wrapper, sidebar);
  wrapper.appendChild(sidebar);
  
  // sidebarの次にpages-mainを挿入し、その中に全てのfaq__sectionを移動
  wrapper.appendChild(pagesMain);
  faqSections.forEach(section => {
    pagesMain.appendChild(section);
  });
};

/**
 * パラメータをお問い合わせフォームに初期値をセット
 * 採用情報と商品情報の両方に対応
 */
workhouse.inquiry.setFormDefaultValues = function() {
  const params = new URLSearchParams(window.location.search);
  const messageBody = document.querySelector('#ContactForm-body');

  if (!messageBody) return; // フォームが存在しない場合は終了

  let prefilledText = "";

  // 1. 採用情報からの遷移パターン
  const subject = params.get('subject');
  const shopName = params.get('shop');

  if (subject || shopName) {
    prefilledText += "【採用情報】\n";
    if (subject)  prefilledText += `${subject}\n`;
    if (shopName) prefilledText += `店舗：${shopName}\n`;
  }

  // 2. 商品ページからの遷移パターン
  const productName = params.get('product_name');
  const productCode = params.get('product_code');

  if (productName || productCode) {
    prefilledText += "【商品お問い合わせ】\n";
    if (productName) prefilledText += `商品名：${productName}\n`;
    if (productCode) prefilledText += `商品コード：${productCode}\n`;
  }

  // テキストがあればフォームに流し込む
  if (prefilledText) {
    prefilledText += "--------------------------\n\n";
    messageBody.value = prefilledText;
  }
};

/**
 * コーディネートページの写真のスライダー
 */
workhouse.coordinate.mainImageSlider = function() {
  // サムネイル側の設定
  const swiperThumbs = new Swiper('.js-slider-thumbs', {
    spaceBetween: 5,
    slidesPerView: 4.7,
    freeMode: true,
    watchSlidesProgress: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true, // ドラッグ操作を可能にする
      hide: false,     // 操作していない時も表示したままにする
    },
    breakpoints: {
      [illm.common.breakpoint.minPc]: {
        slidesPerView: 6.5,
        spaceBetween: 8,
      }
    }
  });

  // メイン側の設定
  const swiperMain = new Swiper('.js-slider-main', {
    thumbs: {
      swiper: swiperThumbs,
    },
  });
};

/**
 * 画像のポップアップで拡大表示
 */
workhouse.shop.lightbox = function() {
  // GLightboxのインスタンスを作成し、動作オプションを設定
  const lightbox = GLightbox({
    touchNavigation: true, // スワイプ操作による画像の切り替え：有効
    loop: false,            // 最後の画像まで行ったら最初に戻る：無効
    closeButton: true,      // 閉じるボタンを表示：有効
  });
};

/**
 * スクロール連動：テキストに合わせて画像を切り替える（フェード）
 */
workhouse.about.initScrollShow = function() {
  // 1. 対象となる「画像」と「トリガーとなる文章」をすべて取得
  const images = gsap.utils.toArray(".js-fade-image");
  const items  = gsap.utils.toArray(".js-scroll-item");

  // どちらかが存在しない場合は処理を中断
  if (!images.length || !items.length) {
    return;
  }

  // 2. 初期状態の設定
  // 全画像を透明(opacity:0)にするが、重なり順などのために存在(visible)はさせておく
  gsap.set(images, { opacity: 0, visibility: "visible", immediateRender: true });
  // 最初の1枚目だけは見えている状態にする
  gsap.set(images[0], { opacity: 1, immediateRender: true });

  // 3. 各文章（item）に対してスクロールイベントを設定
  items.forEach((item, i) => {
    
    // 【A】文章自体のクラス切り替え
    // 文章が画面中央（center）付近に来ている間、その文章に "is-active" クラスを付ける
    ScrollTrigger.create({
      trigger: item,
      start: "top center",
      end: "bottom center",
      toggleClass: { targets: item, className: "is-active" }
    });

    // 【B】対応する画像の表示・非表示切り替え
    if (i < images.length) {
      ScrollTrigger.create({
        trigger: item,
        start: "top 70%",   // 画面の下から30%の位置に入ったら
        end: "bottom 30%",  // 画面の上から30%の位置から出たら
        
        // エリア内に入った時/出た時に実行（self.isActiveで判定）
        onToggle: (self) => {
          // 1. 変数の準備（初期化）
          let targetOpacity;
          let animDuration;
          let animEase;
          let statusLabel;

          // 2. アクティブ状態（エリア内に入ったか）による条件分岐
          if (self.isActive) {
            // --- 表示（フェードイン）時の設定 ---
            targetOpacity = 1;           // 不透明にする
            animDuration = 0.3;          // 少しゆっくり現れる
            animEase = "power2.out";     // 最初は速く、最後に減速（滑らかな着地）
            statusLabel = "✅ 表示 (Fade In)";
          } else {
            // --- 非表示（フェードアウト）時の設定 ---
            targetOpacity = 0;           // 透明にする
            animDuration = 0.2;          // 素早く消える
            animEase = "power2.in";      // 徐々に加速しながら消える
            statusLabel = "❌ 非表示 (Fade Out)";
          }

          // 3. コンソールにデバッグ情報を出力
          // Index番号、対象のHTML要素、現在の状態をログに流します
          console.log(`[Debug] Index: ${i}`, `| Status: ${statusLabel}`, `| Target Element:`, images[i]);
          // -----------------------
          gsap.to(images[i], {
            opacity: targetOpacity,
            duration: animDuration,
            ease: animEase,
            overwrite: "auto"
          });
        },
        
        // ページ読み込み直しやリサイズ時、すでにその場所にいたら表示させる
        onRefresh: (self) => {
          if (self.progress > 0) {
            gsap.set(images[i], { opacity: 1 });
          }
        }
      });
    }
  });

  // 4. 最後の要素に対する予備の設定
  // スクロールしきった時に最後の画像が消えっぱなしにならないよう、
  // 最後の文章が画面下端に来たら最終画像を表示させる
  if (items.length > 0 && images.length > 0) {
    ScrollTrigger.create({
      trigger: items[items.length - 1],
      start: "top bottom",
      onEnter: () => {
        gsap.to(images[images.length - 1], { opacity: 1, duration: 0.5 });
      }
    });
  }

  // 5. ScrollTriggerの計算を最新の状態に更新
  ScrollTrigger.refresh();
}

/*
 * ========================================
 * 初期処理（DOM操作準備完了）
 * ========================================
 */
document.addEventListener('DOMContentLoaded', function () {
  // ----------------------------------------
  // Common
  // ----------------------------------------
  // NEWアイコンの表示制御
  if($( '.js-new-icon' ).length){
    // 現在時刻をサーバーから取得
    illm.common.getServerDate().then( date => {
      const periodDays = 10;// NEWアイコンを表示する期間（日数）
      illm.common.newicon(date, periodDays);
    });
  }
 
  // メニュー展開
  if($('.js-menu-container').length){
    illm.common.toggleHeaderMenu();
  }

  // アコーディオンメニュー
  if( $('.js-accordion-button').length ){
    illm.common.accordionMenu();
  }

  // ----------------------------------------
  // Cart
  // ----------------------------------------
  if ($('.page-cart').length) {
    // 購入制御のため、数量変更・削除したらリロード
    if( $('.cart__blocks .js-contents').length ){
      workhouse.cart.refreshCartOnUpdate();
    }
  }

  // ----------------------------------------
  // Brand List
  // ----------------------------------------
  if ($('.page-brand-list').length) {
    // ブランドリストの絞り込み
    if($('.js-alphabet-nav').length){
      workhouse.brandlist.filter();
    }
  }

  // ----------------------------------------
  // Faq
  // ----------------------------------------
  if ($('.page-faq').length) {
    // レイアウト組み替え（サイドナビとメインエリアのラップ）
    workhouse.faq.setupLayout();
  }

  // ----------------------------------------
  // Contact
  // ----------------------------------------
  if ($('.page-inquiry').length) {
    // パラメータをお問い合わせフォームに初期値をセット
    workhouse.inquiry.setFormDefaultValues();
  }

});

/*
 * ========================================
 * 初期処理（（HTML解析後の最速タイミング））
 * ========================================
 */
window.addEventListener('load', function () {
  // ----------------------------------------
  // Common
  // ----------------------------------------    

  // タブ切り替え
  if($('.js-tab__container').length){
    illm.common.tabswitch();
  }

  //PCヘッダーのカテゴリメニューのスライダー
  if($('.js-category-menu-slider').length){
    workhouse.common.categoryMenuSlider();
  }

  // 商品リストのスライダー（NEW ARRIVAL / 関連商品）
  if($('.js-itemlist-swiper').length){
    workhouse.common.itemlist();
  }
  
  // ----------------------------------------
  // Top
  // ----------------------------------------
  if ($('.page-index').length) {
    // メインビジュアルのスライダー
    if($('.js-home-visual-swiper').length){
      workhouse.top.mainvisual();
    }

    // メインビジュアル下部のバナーのスライダー
    if($('.js-home-banner-swiper').length){
      workhouse.top.mainbanner();
    }
    
    // COORDINATEのスライダー
    if($('.js-coordinate-swiper').length){
      workhouse.top.coordinateSlider();
    }

  }

  // ----------------------------------------
  // ItemDetail
  // ----------------------------------------
  if ($('.page-product').length) {
    // 商品画像のサムネイルのスライダー
    workhouse.itemDetail.thumbnailSlider();

    // JANコードを取得
    if($('#store-stock-button').length){
      // workhouse.itemDetail.getJancode();　※システムの都合上見送り 20260318※
    }
   
    // COORDINATEのスライダー
    if($('.js-product-coordinate-swiper').length){
      workhouse.itemDetail.coordinateSlider();
    }
  }

  // ----------------------------------------
  // Coordinate
  // ----------------------------------------
  if ($('.page-article.blog-coordination').length) {
    // コーディネート写真のスライダー
    workhouse.coordinate.mainImageSlider();
  }

  // ----------------------------------------
  // Shop
  // ----------------------------------------
  if ($('.page-retail_store').length) {
    // 画像のポップアップで拡大表示
    workhouse.shop.lightbox();
  }

  // ----------------------------------------
  // About
  // ----------------------------------------
  if ($('.js-scroll-show-images').length) {
    // PCでだけ
    if (window.matchMedia('(min-width: 990px)').matches) {
      // スクロールに応じて画像を切り替え
      workhouse.about.initScrollShow();
    }
  }



});